import { render, staticRenderFns } from "./Bdr2026SolveConflicts.vue?vue&type=template&id=5dfc27ac&scoped=true&"
import script from "./Bdr2026SolveConflicts.vue?vue&type=script&lang=js&"
export * from "./Bdr2026SolveConflicts.vue?vue&type=script&lang=js&"
import style0 from "./Bdr2026SolveConflicts.vue?vue&type=style&index=0&id=5dfc27ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfc27ac",
  null
  
)

export default component.exports